import { createTokensFromScale } from '../../utils/createTokensFromScale';
export const defaultSpacingScale = {
    prefix: 'twist-core-spacing',
    steps: {
        base: { size: 3, unit: 'px' },
        0: { size: 0 },
        '0_5': { multiplier: 0.5 },
        1: { multiplier: 1 },
        '1_5': { multiplier: 1.5 },
        2: { multiplier: 2 },
        3: { multiplier: 3 },
        4: { multiplier: 4 },
        5: { multiplier: 5 },
        6: { multiplier: 6 },
        7: { multiplier: 7 },
        8: { multiplier: 8 },
        9: { multiplier: 9 },
        10: { multiplier: 10 },
        12: { multiplier: 12 },
        15: { multiplier: 15 },
        20: { multiplier: 20 },
        25: { multiplier: 25 },
        30: { multiplier: 30 },
        40: { multiplier: 40 },
        50: { multiplier: 50 },
        60: { multiplier: 60 },
        70: { multiplier: 70 },
        90: { multiplier: 90 },
        100: { multiplier: 100 },
        150: { multiplier: 150 },
        200: { multiplier: 200 }
    }
};
// generates the following tokens:
// export const defaultSpacingTokens = {
//   'twist-core-spacing-base': '3px',
//   'twist-core-spacing-0': '0',
//   'twist-core-spacing-0_5': 'calc(0.5 * var(--twist-core-spacing-base))',
//   'twist-core-spacing-1': 'var(--twist-core-spacing-base)',
//   'twist-core-spacing-1_5': 'calc(1.5 * var(--twist-core-spacing-base))',
//   'twist-core-spacing-2': 'calc(2 * var(--twist-core-spacing-base))',
//   'twist-core-spacing-3': 'calc(3 * var(--twist-core-spacing-base))',
//   'twist-core-spacing-4': 'calc(4 * var(--twist-core-spacing-base))',
//   'twist-core-spacing-5': 'calc(5 * var(--twist-core-spacing-base))',
//   'twist-core-spacing-6': 'calc(6 * var(--twist-core-spacing-base))',
//   'twist-core-spacing-7': 'calc(7 * var(--twist-core-spacing-base))',
//   'twist-core-spacing-8': 'calc(8 * var(--twist-core-spacing-base))',
//   'twist-core-spacing-9': 'calc(9 * var(--twist-core-spacing-base))',
//   'twist-core-spacing-10': 'calc(10 * var(--twist-core-spacing-base))',
//   'twist-core-spacing-12': 'calc(12 * var(--twist-core-spacing-base))',
//   'twist-core-spacing-15': 'calc(15 * var(--twist-core-spacing-base))',
//   'twist-core-spacing-20': 'calc(20 * var(--twist-core-spacing-base))',
//   'twist-core-spacing-25': 'calc(25 * var(--twist-core-spacing-base))',
//   'twist-core-spacing-30': 'calc(30 * var(--twist-core-spacing-base))',
//   'twist-core-spacing-40': 'calc(40 * var(--twist-core-spacing-base))',
//   'twist-core-spacing-50': 'calc(50 * var(--twist-core-spacing-base))',
//   'twist-core-spacing-60': 'calc(60 * var(--twist-core-spacing-base))',
//   'twist-core-spacing-70': 'calc(70 * var(--twist-core-spacing-base))',
//   'twist-core-spacing-90': 'calc(90 * var(--twist-core-spacing-base))',
//   'twist-core-spacing-100': 'calc(100 * var(--twist-core-spacing-base))',
//   'twist-core-spacing-150': 'calc(150 * var(--twist-core-spacing-base))',
//   'twist-core-spacing-200': 'calc(200 * var(--twist-core-spacing-base))'
// }
export const defaultSpacingTokens = createTokensFromScale(defaultSpacingScale);
